/* istanbul ignore file */
import { getEnv } from '@/lib/env';
import { ENV } from '@/lib/const';

export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATETIME_FORMAT = 'd MMM yyy, h:mm aaa';
export const DATEONLY_FORMAT = 'd MMM yyy';

export enum Namespace {
  ELMO_AU = 'elmoau',
  ELMO_GOV_AU = 'elmoaugov',
  ELMO_GLOBAL = 'elmoglobal',
  ELMO_NZ = 'elmonz',
  ELMO_UK = 'elmouk',
  BREATHE_AU = 'breatheau',
  BREATHE_UK = 'breatheuk',
  ELMO_DEV = 'elmodev',
}

export const NAMESPACE_DOMAIN_MAPPING = {
  [Namespace.ELMO_DEV]: 'elmodev.com',
  [Namespace.ELMO_AU]: 'elmotalent.com.au',
  [Namespace.ELMO_GOV_AU]: 'elmogov.com.au',
  [Namespace.ELMO_GLOBAL]: 'elmotalent.com',
  [Namespace.ELMO_NZ]: 'elmotalent.co.nz',
  [Namespace.ELMO_UK]: 'elmosoftware.co.uk',
  [Namespace.BREATHE_AU]: 'breathehr.com.au',
  [Namespace.BREATHE_UK]: 'breathehr.co.uk',
};

export const isStaging = getEnv() === ENV.names.staging;

export const MULTI_REGION_TARGETS = [
  ...(isStaging
    ? [{ namespace: Namespace.ELMO_DEV, name: 'Sydney Staging (Australia)' }]
    : []),
  {
    namespace: Namespace.ELMO_AU,
    name: 'Sydney (Australia)',
  },
  { namespace: Namespace.ELMO_UK, name: 'London (UK)' },
  { namespace: Namespace.ELMO_GOV_AU, name: 'Sydney Gov (Australia)' },
];

export default {
  DATE_FORMAT,
  DATETIME_FORMAT,
};
